// extracted by mini-css-extract-plugin
export var image = "_i8-0";